export default {
  'menuSettings.showMemberPrice': 'Show member price',
  'menuSettings.defaultWeightForOpenPriceDishes': 'Set default weight unit for open price dishes',
  'menuSettings.weightNoUnit': 'No weight unit',
};
